"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "configs", {
  enumerable: true,
  get: function get() {
    return _configs.default;
  }
});
Object.defineProperty(exports, "MobileTable", {
  enumerable: true,
  get: function get() {
    return _index.default;
  }
});
exports.default = void 0;

require("core-js/modules/es6.array.sort");

require("core-js/modules/web.dom.iterable");

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _impression = require("@nerdwallet/analytics/react/impression");

var _classnames = _interopRequireDefault(require("classnames"));

var _tableHeaders = _interopRequireDefault(require("./table-headers/table-headers"));

var _productRow = _interopRequireDefault(require("./product-row/product-row"));

var _configs = _interopRequireDefault(require("./configs"));

var _index = _interopRequireDefault(require("./mobile-brokerage-table/index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
// Components

/**
 * This component displays a results table.
 *
 * @class
 *
 * @property {String} tableName - The name of the table.
 * @property {Object} viewConfig - The view config for the results table.
 * @property {Array} products - The raw data as sent by the service.
 * @property {String} sortKey - The sort key for which the data is sorted on.
 * @property {Object} hooks - Custom hooks that the table needs to provide actions to.
 * @property {Boolean} [mustClickToggleForDrawer=false] - if true, the drawer will only open
 *  if the user clicks the details toggle. Clicking on the row will not open the drawer.
 */
var ProductTable = function ProductTable(_ref) {
  var analytics = _ref.analytics,
      tableName = _ref.tableName,
      customComponents = _ref.customComponents,
      products = _ref.products,
      sortKey = _ref.sortKey,
      hooks = _ref.hooks,
      tableConfig = _ref.tableConfig,
      detailsComponent = _ref.detailsComponent,
      mustClickToggleForDrawer = _ref.mustClickToggleForDrawer;

  // Render columns renders empty divs that can be used to style every table-cell
  // in a column.
  function renderColumns() {
    var cols = [];
    var key = sortKey || tableConfig.defaultSortKey;
    tableConfig.columns.forEach(function (column, idx) {
      cols.push(_react.default.createElement("col", {
        key: idx,
        className: (0, _classnames.default)('table-column', {
          'sorting-by': key === (column.sort && column.sort.key)
        })
      }));
    });
    return cols;
  }

  function renderRows() {
    return products.map(function (product, i) {
      var productRowProps = {
        analytics: analytics,
        key: "product-row-".concat(i),
        data: product,
        viewConfig: tableConfig,
        customComponents: customComponents,
        tableName: tableName,
        reviewTarget: tableConfig.reviewTarget,
        detailsComponent: detailsComponent,
        mustClickToggleForDrawer: mustClickToggleForDrawer,
        productIndex: i
      };
      return _react.default.createElement(_productRow.default, productRowProps);
    });
  }

  return _react.default.createElement(_impression.Impression, {
    entityName: (0, _get2.default)(analytics, 'productTableAllOffers.entityName'),
    eventType: "marketplace_offers_impression",
    payload: {
      element_position: (0, _get2.default)(analytics, 'productTableAllOffers.elementPosition'),
      section_name: (0, _get2.default)(analytics, 'productTableAllOffers.sectionName'),
      section_position: (0, _get2.default)(analytics, 'productTableAllOffers.sectionPosition'),
      additional_attributes: {
        marketplace_offers_count: products.length,
        marketplace_offer_ids: (0, _map2.default)(products, function (product) {
          return product.id;
        }),
        marketplace_product_type: (0, _get2.default)(analytics, 'productTableAllOffers.productType')
      },
      parent_impression_id: (0, _get2.default)(analytics, 'productTableAllOffers.parentImpressionId')
    },
    enabled: !(0, _isEmpty2.default)(analytics)
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)('product-table-wrapper', tableConfig.className)
  }, _react.default.createElement("table", {
    className: "product-table"
  }, _react.default.createElement("colgroup", null, renderColumns()), _react.default.createElement(_tableHeaders.default, {
    hooks: hooks,
    viewConfig: tableConfig,
    sortKey: sortKey
  }), renderRows())));
};

ProductTable.displayName = 'ProductTable';
ProductTable.defaultProps = {
  mustClickToggleForDrawer: false
};
ProductTable.propTypes = {
  analytics: _propTypes.default.shape({
    productTable: _propTypes.default.shape({
      pageNumber: _propTypes.default.number,
      sectionName: _propTypes.default.string,
      sectionPosition: _propTypes.default.number
    }),
    productTableAllOffers: _propTypes.default.shape({
      entityName: _propTypes.default.string,
      elementPosition: _propTypes.default.number,
      parentImpressionId: _propTypes.default.string,
      productType: _propTypes.default.string,
      sectionName: _propTypes.default.string,
      sectionPosition: _propTypes.default.number
    }),
    detailsDrawer: _propTypes.default.shape({
      entityName: _propTypes.default.string
    })
  }),
  tableName: _propTypes.default.string,
  customComponents: _propTypes.default.object,
  products: _propTypes.default.array,
  sortKey: _propTypes.default.string,
  hooks: _propTypes.default.object,
  tableConfig: _propTypes.default.object,
  detailsComponent: _propTypes.default.func,
  mustClickToggleForDrawer: _propTypes.default.bool
};
var _default = ProductTable;
exports.default = _default;